import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ background: '#0F0B2D', padding: '120px 24px', position: 'relative', overflow: 'hidden' }}>
      <style>{`
        @keyframes ctaBlob {
          0%, 100% { transform: translate(0,0) scale(1); }
          50% { transform: translate(30px,-20px) scale(1.08); }
        }
        .cta-primary-btn {
          transition: all 0.2s ease;
        }
        .cta-primary-btn:hover {
          background: #fff !important;
          transform: translateY(-2px) !important;
          box-shadow: 0 8px 24px rgba(129,140,248,0.2) !important;
        }
        .cta-secondary-btn {
          transition: all 0.2s ease;
        }
        .cta-secondary-btn:hover {
          background: rgba(255,255,255,0.12) !important;
          transform: translateY(-2px) !important;
        }
      `}</style>

      {/* Subtle decorative blobs */}
      <div style={{ position: 'absolute', top: '-20%', left: '-10%', width: 600, height: 600, borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.04) 0%, transparent 65%)', filter: 'blur(60px)', animation: 'ctaBlob 12s ease-in-out infinite', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-20%', right: '-10%', width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(129,140,248,0.06) 0%, transparent 65%)', filter: 'blur(80px)', pointerEvents: 'none' }} />

      <div style={{ maxWidth: 860, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <div style={{
          textAlign: 'center',
          opacity: visible ? 1 : 0,
          transform: visible ? 'none' : 'translateY(24px)',
          transition: 'all 0.7s ease',
        }}>
          {/* Tag */}
          <div className="mono-label" style={{ color: 'rgba(255,255,255,0.4)', marginBottom: 28 }}>
            <span style={{ color: '#818CF8' }}>/</span> Get started today
          </div>

          {/* Headline */}
          <h2 style={{ fontSize: 'clamp(32px,5.5vw,68px)', fontWeight: 700, color: '#fff', letterSpacing: '-0.04em', lineHeight: 1.05, marginBottom: 20 }}>
            Ready to scale your<br />
            <em className="serif-accent" style={{ color: '#818CF8' }}>ad operations?</em>
          </h2>

          {/* Sub */}
          <p style={{ fontSize: 'clamp(14px,2vw,17px)', color: 'rgba(255,255,255,0.55)', maxWidth: 520, margin: '0 auto 40px', lineHeight: 1.7 }}>
            Join hundreds of media buyers who saved hours every week. Free to start — no credit card needed.
          </p>

          {/* CTAs */}
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 32 }}>
            <Link
              to="/signup"
              className="cta-primary-btn"
              style={{
                padding: '16px 40px',
                borderRadius: 999,
                background: '#818CF8',
                color: '#0F0B2D', fontWeight: 700, fontSize: 15,
                textDecoration: 'none',
                display: 'inline-block',
                fontFamily: "'Space Grotesk',sans-serif",
              }}
            >
              Start for Free
            </Link>
            <Link
              to="/login"
              className="cta-secondary-btn"
              style={{
                padding: '16px 40px',
                borderRadius: 999,
                background: 'transparent',
                border: '1px solid rgba(255,255,255,0.2)',
                color: 'rgba(255,255,255,0.75)', fontWeight: 500, fontSize: 15,
                textDecoration: 'none',
                display: 'inline-block',
              }}
            >
              Sign in →
            </Link>
          </div>

          {/* Trust row */}
          <div style={{ display: 'flex', gap: 24, justifyContent: 'center', flexWrap: 'wrap' }}>
            {['No credit card required', 'Cancel anytime', '200+ teams onboarded'].map((t, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: 'rgba(255,255,255,0.4)' }}>
                <span style={{ color: '#818CF8', fontSize: 10 }}>✓</span> {t}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
